import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StringConstant from '../../constants/StringConstants';
import NavigateToWebApps from '../../utils/NavigateToWebApps';
import envConfig from '../../../static/config';
import InternetBankingActions from '../../actions/InternetBankingActions';
import UserManagementStore from '../../stores/UserManagementStore';
import AccountsStore from '../../stores/AccountsStore';
import { saveNavigationReference } from '../../actions/PaymentStatusActionCreator';
import MoveMoneyActionCreator from '../../actions/MoveMoneyActionCreator';
import SvgIcon from '../common/SvgIcon';
import MoveMoneyStore from '../../stores/MoveMoneyStore';
import { isVMBusiness } from '../../utils/BrandUtils';

const getLinkItem = (handleClick, linkText) => (
  <li className="c-panel__item">
    <button className="c-panel__sblink" onClick={handleClick}>
      {linkText}
    </button>
  </li>
);

class QuickLinksTile extends Component {
  constructor(props) {
    super(props);
    this.handlePaymentStatusClick = this.handlePaymentStatusClick.bind(this);
    this.handleMobileAccessClick = this.handleMobileAccessClick.bind(this);
    this.handleUserManagementClick = this.handleUserManagementClick.bind(this);
    this.handleManageYourPayeeClick =
      this.handleManageYourPayeeClick.bind(this);
  }

  handleMobileAccessClick() {
    NavigateToWebApps.navigateTo(envConfig.deviceManagementLink);
  }

  handlePaymentStatusClick() {
    saveNavigationReference('WEB-HOMEPAGE');
    InternetBankingActions.navigateToWebTask('WEB-MANAGE-PAYMENT-STATUS');
  }

  handleUserManagementClick() {
    NavigateToWebApps.navigateTo(envConfig.userManagementLink);
  }
  handleGivingNoticeClick() {
    saveNavigationReference('WEB-HOMEPAGE');
    InternetBankingActions.navigateToWebTask('WEB-GIVING_NOTICE');
  }

  handleManageYourPayeeClick() {
    MoveMoneyActionCreator.saveNavigationReference('WEB-HOMEPAGE');
    MoveMoneyStore.setDisplayManagePayeePage(true);
    InternetBankingActions.navigateToWebTask('WEB-OPEN-MOVEMONEY');
  }

  render() {
    const listItemsWithIcons = [];
    if (AccountsStore.getTotalNumberOfAccounts() > 0) {
      listItemsWithIcons.push(
        getLinkItem(
          this.handlePaymentStatusClick,
          StringConstant.paymentStatusQuickLink
        )
      );
    }
    if (
      envConfig.isDeviceManagementEnabled &&
      UserManagementStore.isManageDeviceEnabled() &&
      !UserManagementStore.isNominatedUser()
    ) {
      listItemsWithIcons.push(
        getLinkItem(
          this.handleMobileAccessClick,
          StringConstant.mobileDeviceAccessQuickLink
        )
      );
    }
    if (
      envConfig.isUserManagementEnabled &&
      UserManagementStore.isUserReadEnabled()
    ) {
      listItemsWithIcons.push(
        getLinkItem(
          this.handleUserManagementClick,
          StringConstant.userManagementQuickLink
        )
      );
    }
    if (AccountsStore.getManagePayeesFlag()) {
      listItemsWithIcons.push(
        getLinkItem(
          this.handleManageYourPayeeClick,
          StringConstant.manageYourPayeeQuickLink
        )
      );
    }
    if (
      UserManagementStore.isCA() &&
      AccountsStore.shouldShowGiveNoticeQuickLink()
    ) {
      listItemsWithIcons.push(
        getLinkItem(
          this.handleGivingNoticeClick,
          StringConstant.givingNoticeQuickLink
        )
      );
    }
    if (listItemsWithIcons.length) {
      return (
        <div
          id="site-sidebar"
          tabIndex="-1"
          className="c-panel l-tile c-quicklink-tile"
        >
          <div className="c-panel-info">
            <h3 className="c-panel__heading">
              {!isVMBusiness() && (
                <span className="c-panel__icons">
                  <SvgIcon id="icon-quickLinks" width="16px" height="16px" />
                </span>
              )}
              {StringConstant.quickLinkTitle}
            </h3>
            <div className="c-panel__body">
              <ul className="c-panel__list">{listItemsWithIcons}</ul>
            </div>
          </div>
        </div>
      );
    }
    return null;
  }
}

QuickLinksTile.propTypes = {
  data: PropTypes.string,
  content: PropTypes.shape({}),
};
export default QuickLinksTile;
